module.exports = __webpack_public_path__ + "static/media/chime.7285bcc5.mp3";